import React from 'react';
import PropTypes from 'prop-types';
import { appConfig } from 'config/appConfig';
import cx from 'classnames';

/**
 *
 * @param {boolean} fixed center the loading component even onscrolling
 */
const Loading = ({ fullScreen, fixed }) => {
  return (
    <div className={cx('loading', { 'loading--full-screen': fullScreen, 'loading--fixed': fixed })}>
      <img src={appConfig.loadingIndicator} alt="loading" />
    </div>
  );
};

Loading.propTypes = {
  fullScreen: PropTypes.bool,
  fixed: PropTypes.bool,
};
Loading.defaultProps = {
  fullScreen: false,
  fixed: false,
};

export default Loading;
